// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React, { ChangeEvent } from "react";

import { SchoolDocument } from "../store/schema";

interface SchoolChooserProps {
  id?: string;
  schoolUid: string;
  schools: SchoolDocument[];
  onChangeSchool: (uid: string) => void;
}

export const SchoolChooser: React.FC<SchoolChooserProps> = ({
  id,
  schoolUid,
  schools,
  onChangeSchool,
}) => {
  function onChange(e: ChangeEvent<HTMLSelectElement>) {
    const uid = e.target.value;
    onChangeSchool(uid);
  }

  const headerDoc = {
    data: { uid: "", name: "<Choose a school>" },
  };
  const choices = [headerDoc, ...schools];
  return (
    <select
      id={id}
      disabled={schools.length === 0}
      onChange={onChange}
      value={schoolUid}
    >
      {choices.map(x => (
        <option key={x.data.uid} value={x.data.uid}>
          {x.data.name}
        </option>
      ))}
    </select>
  );
};
